module.exports = __webpack_public_path__ + "img/img4.51bc62af.png";